import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SubNavbar from "../../../layout/SubNavbar/index";

export default function ViewBlogDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  // Extract the state from the location object
  const blogData = location?.state?.blogData;
  const [step, setStep] = useState(1);

  const handleStepChange = (newStep) => setStep(newStep);

  return (
    <div className="content">
      <div className="container-fluid">
        <SubNavbar
          title={`Blog Details`}
          header={`Blog`}
          subHeader={`View Blog Details`}
        />
        <div className="card rounded-3 mt-3">
          <div className="card-body">
            <div className="d-flex justify-content-start">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => navigate(-1)}
              >
                <i className="bi bi-arrow-left"></i> Back
              </button>
            </div>
            {/* Images Section */}
            <div className="row mb-4 d-flex justify-content-center">
              <div className="col-md-6 text-center">
                <h5>Blog Image</h5>
                <img
                  src={blogData?.blog_image}
                  alt="Letter Image"
                  className="img-fluid img-thumbnail"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "10%",
                  }}
                />
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <div className="card w-75 mt-2 shadow-lg">
                <div className="card-body">
                  <div className="row">
                    <div className="mb-3 col-6">
                      <h5>Blog Title</h5>
                      <p>{blogData?.title || "N/A"}</p>
                    </div>
                    <div className="mb-3 col-6">
                      <h5>Blog Arebic Title</h5>
                      <p>{blogData?.ar_title || "N/A"}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-3 col-12">
                    <h5>Description</h5>
                    <p>{blogData?.description || "N/A"}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-3 col-12">
                    <h5>Arebic Description</h5>
                    <p>{blogData?.ar_description || "N/A"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
              <button
                className="btn btn-primary m-1"
                onClick={() =>
                  navigate("/manage_blog/edit_blog", {
                    state: { blogData:blogData },
                  })
                }
              >
                Edit Blog
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
